import React, { useCallback, useEffect } from "react";
import NepaliDate from "nepali-date-converter";
import { ADToBS, BSToAD } from "bikram-sambat-js";
import { InputDiv } from "../../assets/StyledComponent/Input/Input.Style";
import {
  getFoodTotalExpenseDownloadService,
  getFoodTotalExpenseService,
  getFoodCompanyExpenseService,
  getCmpFoodTotalExpenseDownloadService,
} from "../../services/cFoodExpenseReportService";
import { useStore } from "../../store";
import "../TotalExpenseReport/styles.css";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import {
  GET_CMP_USER_REPORT_FAILURE,
  GET_CMP_USER_REPORT_SUCCESS,
} from "../../container/SCmpUserReport/types";
import { sCmpUserReportService } from "../../services/sCmpUserReportService";
import {
  GET_CFOOD_TOTAL_EXPENSE_REPORT,
  GET_CFOOD_TOTAL_EXPENSE_REPORT_FAILURE,
  SET_ALL_REPORT_BY_FALSE,
  SET_FROM_TIME,
  SET_REPORT_BY_NEPALI_DATE,
  SET_TO_TIME,
  UNSET_REPORT_BY_NEPALI_DATE,
} from "../../container/FoodReport/types";
interface Iprops {
  companyId: string;
  reportType?: string;
}
const UserReport = ({ companyId, reportType }: Iprops) => {
  const [state, dispatch]: any = useStore();
  const [date, setDate] = React.useState({ year: "", month: "" });

  const valueOfEye = state.foodReportReducer?.nepaliDate;

  // const iconSet = useCallback(() => {
  //   if (state.foodReportReducer?.nepaliDate === true) {
  //     return <AiFillEye />;
  //   } else {
  //     return <AiFillEyeInvisible />;
  //   }
  // }, [state.foodReportReducer?.nepaliDate]);

  // useEffect(() => {
  //   iconSet();
  // }, [iconSet, state.foodReportReducer.nepaliDate]);

  // console.log("nepali Date", eyeOpen);

  const month = [
    {
      name: "Baishakh",
      value: "01",
    },
    {
      name: "Jestha",
      value: "02",
    },
    {
      name: "Ashadh",
      value: "03",
    },
    {
      name: "Shrawan",
      value: "04",
    },
    {
      name: "Bhadra",
      value: "05",
    },
    {
      name: "Ashwin",
      value: "06",
    },
    {
      name: "Kartik",
      value: "07",
    },
    {
      name: "Mangsir",
      value: "08",
    },
    {
      name: "poush",
      value: "09",
    },
    {
      name: "Magh",
      value: "10",
    },
    {
      name: "Falgun",
      value: "11",
    },
    {
      name: "Chaitra",
      value: "12",
    },
  ];

  const year = [
    {
      name: "2079",
      value: "2079",
    },
    {
      name: "2080",
      value: "2080",
    },
    {
      name: "2081",
      value: "2081",
    },
    {
      name: "2082",
      value: "2082",
    },
    {
      name: "2083",
      value: "2083",
    },
    {
      name: "2084",
      value: "2084",
    },
    {
      name: "2085",
      value: "2085",
    },
    {
      name: "2086",
      value: "2086",
    },
    {
      name: "2087",
      value: "2087",
    },
    {
      name: "2088",
      value: "2088",
    },
    {
      name: "2089",
      value: "2089",
    },
    {
      name: "2090",
      value: "2090",
    },
  ];

  React.useEffect(() => {
    const currentDate = new NepaliDate(Date.now());
    const startDate = new NepaliDate(
      currentDate.getYear(),
      currentDate.getMonth(),
      1
    ).toJsDate();

    const nepaliStartDate = ADToBS(startDate.toLocaleDateString());
    setDate({
      year: nepaliStartDate.slice(0, 4),
      month: nepaliStartDate.slice(5, 7),
    });
  }, []);

  const handleFoodTotalExpense = () => {
    const fromDate = date && BSToAD(`${date.year}-${date.month}-01`);

    const toDate =
      date && date.month === "12"
        ? BSToAD(`${date.year}-${parseInt(date.month)}-31`)
        : BSToAD(`${date.year}-${parseInt(date.month) + 1}-01`);

    var d = new Date(toDate);

    d.setDate(d.getDate() - 1);

    const toDate_to_send = d.toLocaleDateString("sv-SE");
    // console.log("Today is: " + d.toLocaleString());

    dispatch({
      type: SET_REPORT_BY_NEPALI_DATE,
    });

    valueOfEye === true &&
      dispatch({
        type: UNSET_REPORT_BY_NEPALI_DATE,
      });
    dispatch({
      type: SET_FROM_TIME,
      fromDate: fromDate,
    });

    // d.setDate(d.getDate() - 1);
    // const year = d.getFullYear().toString();
    // const month = String(d.getMonth() + 1).padStart(2, "0");
    // const day = String(d.getDate()).padStart(2, "0");
    // const to_date = year + "-" + month + "-" + day;
    dispatch({
      type: SET_TO_TIME,
      toDate: toDate_to_send,
    });
    // console.log(to_date);
    if (companyId) {
      if (reportType === "Food Report") {
        getFoodCompanyExpenseService(fromDate, toDate_to_send, companyId)
          .then((res: any) => {
            dispatch({
              type: GET_CFOOD_TOTAL_EXPENSE_REPORT,
              cTotalExpenseReport: res,
            });
          })
          .catch((err) => {
            dispatch({
              type: GET_CFOOD_TOTAL_EXPENSE_REPORT_FAILURE,
              cTotalExpenseReportError: err,
            });
          });
      } else {
        sCmpUserReportService(fromDate, toDate_to_send, companyId)
          .then((res: any) => {
            dispatch({
              type: GET_CMP_USER_REPORT_SUCCESS,
              SCmpUserReport: res,
            });
          })
          .catch((err: any) => {
            dispatch({
              type: GET_CMP_USER_REPORT_FAILURE,
              SCmpUserReportError: err,
            });
          });
      }
    } else {
      getFoodTotalExpenseService(fromDate, toDate_to_send)
        .then((res: any) => {
          dispatch({
            type: GET_CFOOD_TOTAL_EXPENSE_REPORT,
            cTotalExpenseReport: res,
          });
        })
        .catch((err) => {
          dispatch({
            type: GET_CFOOD_TOTAL_EXPENSE_REPORT_FAILURE,
            cTotalExpenseReportError: err,
          });
        });
    }
  };
  return (
    <InputDiv>
      <div
        className="w-80 text-center rounded d-flex"
        style={
          {
            // width: "68.5%",
            // display: "flex",
            // flexDirection: "row",
            // justifyContent: "space-between",
          }
        }
      >
        <label
          style={{
            whiteSpace: "nowrap",
            display: "flex",
            margin: "0px 20px",
            fontWeight: "500",
          }}
        >
          Select Nepali Year
        </label>
        <select
          style={{
            width: "8.75rem",
            padding: "0.5px 1px",
            borderRadius: "5px",
            background: "white",
          }}
          value={date.year}
          onChange={(e) => {
            dispatch({
              type: SET_ALL_REPORT_BY_FALSE,
            });
            setDate({ ...date, year: e.target.value });
          }}
        >
          {year.map((item) => (
            <option value={item.value} key={item.name}>
              {item.name}
            </option>
          ))}
        </select>
        <label
          style={{
            whiteSpace: "nowrap",
            display: "flex",
            marginLeft: "34px",
            marginRight: "20px",
            fontWeight: "500",
          }}
        >
          Select Nepali Month
        </label>
        <select
          style={{
            width: "8.75rem",
            padding: "0.5px 1px",
            borderRadius: "5px",
            background: "white",
          }}
          value={date.month}
          onChange={(e) => {
            dispatch({
              type: SET_ALL_REPORT_BY_FALSE,
            });
            setDate({ ...date, month: e.target.value });
          }}
        >
          {month.map((item) => (
            <option value={item.value} key={item.name}>
              {item.name}
            </option>
          ))}
        </select>

        {/* <button className="searchBtn" onClick={getTableData}>
          {" "}
          Download{" "}
        </button> */}
        <button
          className="searchBtn"
          type="button"
          style={{
            backgroundColor: valueOfEye ? "#e55607" : "#999",
          }}
          onClick={handleFoodTotalExpense}
        >
          {valueOfEye ? <AiFillEye /> : <AiFillEyeInvisible />}
        </button>
      </div>
    </InputDiv>
  );
};

export default UserReport;
